import React from 'react'
import { MainWrap } from '../../utilities/Shared'

const Acualvsestimate = () => {
  return (
    <MainWrap>Acualvsestimate</MainWrap>
  )
}

export default Acualvsestimate